export { loadRailsPayload } from './load-rails-payload'
